import React from "react";
import "./style.scss";
import IconPastpuller from "../SvgIcons/IconPastpuller";
import IconUpgradesMarket from "../SvgIcons/IconUpgradesMarket";
import { Link } from "react-router-dom";
import IconRight from "../SvgIcons/IconRight";

export default function AdminFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="dashboard-copyright">
      <div className="footer-boxadmin">
        <h5>
          <IconPastpuller /> PastPuller™
        </h5>
        <p>Import, backup, & secure external memories.</p>
        <Link to="#">
          <IconRight />
        </Link>
      </div>
      <div className="footer-boxadmin">
        <h5>
          <IconUpgradesMarket /> Upgrades Market
        </h5>
        <p>Find features to customize your expereince.</p>
        <Link to="#">
          <IconRight />
        </Link>
      </div>
      <div className="copyright-text">
        <p>Version 3.19 (30)</p>
        <p>Copyright {currentYear} Seize LLC.</p>
        <p>All Rights Reserved</p>
      </div>
    </div>
  );
}
